/* eslint-disable camelcase */
import React from 'react';
import { RichText } from 'prismic-reactjs';
import AccordionItem from '@components/shared/Accordion/AccordionItem/AccordionItem';
import env from '@lib/envs/env';
import { asText } from '@lib/prismic/util/document';
import classNames from 'classnames';
import { useTheme } from '@components/theme';
import Divider from '@components/shared/Divider/Divider';
import { IPrismicText } from '@lib/prismic/types';
import styles from './FAQ.module.scss';

export interface IFaqItem {
  question?: IPrismicText[];
  answer?: IPrismicText[];
}

interface IFaqProps {
  className?: string;
  faq_title?: IPrismicText[];
  faq_items?: IFaqItem[];
}

export default function FAQ({
  className = '',
  faq_title = [],
  faq_items = []
}: IFaqProps) {
  if (!hasQuestions(faq_items)) return (null);

  const theme = useTheme();

  return (
    <div className={classNames(className, styles.Root, theme.styles.Section, theme.styles.Core5)}>
      <h2
        className={classNames(
          styles.Header,
          theme.styles.Header
        )}
      >
        {asText(faq_title, 'Frequently Asked Questions')}
      </h2>

      <p className={classNames(
        theme.styles.Body,
        styles.Subtitle
      )}
      >
        For more FAQs, visit our <a href={env.HELP_CENTER_URL}>Help Center</a>.
      </p>

      <Divider className={styles.Divider} />
      {faq_items.map((faq_item) => {
        const { question, answer } = faq_item;
        if (!(question && answer)) return null;

        return (
          <AccordionItem
            key={asText(question)}
            title={asText(question)}
            showDivider
            showIcon
            dividerClassName={styles.Divider}
            itemClassName={styles.AccordionItem}
            iconClassName={styles.AccordionIcon}
            className={styles.FAQAccordion}
            headerButtonClass={styles.AccordionHeader}
          >
            {RichText.render(answer)}
          </AccordionItem>
        );
      })}
    </div>
  );
}

function hasQuestions(items: IFaqItem[]) {
  return items.some((item) => item.question?.length && item.answer?.length);
}
